import {SSLAConfiguration} from "./config";

let openConfig:SSLAConfiguration;
let isSingleActivity:boolean;
let openUrl:string;
let currentPopupHandle:Window = null;

function openPage(location:string, windowName:string, settings:string) {
    currentPopupHandle = window.open(location, windowName, settings);
    if (currentPopupHandle == null || typeof(currentPopupHandle) == 'undefined') {
        //alert('Please disable your pop-up blocker and click the link again.');
    }
    else {
        currentPopupHandle.focus();

        // Watch for when the popup closes.
        var pollTimer = window.setInterval(function() {
            let behavior:string;
            let behaviorCustomFn:any;
            if (currentPopupHandle.closed !== false) { // !== is required for compatibility with Opera
                window.clearInterval(pollTimer);
                currentPopupHandle = null;

                // Single SCO or multi SCO?
                if (isSingleActivity) {
                    // Single SCO
                    behavior = openConfig.closePopupSingleScoBehavior();
                    behaviorCustomFn = openConfig.closePopupSingleScoCustomFunction();
                }
                else {
                    // Multi SCO
                    behavior = openConfig.closePopupMultiScoBehavior();
                    behaviorCustomFn = openConfig.closePopupMultiScoCustomFunction();
                }

                if (behavior == "") {
                    // Do nothing.
                }
                else if (behavior == "exit") {
                    // TODO Something less abusive of global variables.
                    (<any>window).ssla.ssla.exit();
                }
                else if (behavior == "message") {
                    alert("TODO message();");
                }
                else if (behavior == "custom") {
                    if (!behaviorCustomFn) {
                        console.log("No exit custom behavior function defined in config.");
                    }
                    else {
                        behaviorCustomFn();
                    }
                }
                else {
                    console.log("Unrecognized exit behavior:", behavior);
                }

            }
        }, 200);

    }
    return currentPopupHandle;
};

function tryPopup(path:string, popupSettings:string) {
    return openPage(path, openConfig.popupName(), popupSettings);
}

function makePopup() {
    return tryPopup(openUrl, openConfig.popupWindowParams());
}

export function popupManually() {
    updateUserText();
    return makePopup();
}

function updateCenterContent(s:string) {
    var handle = setInterval(function() {
        try {
            // TODO: Improve the frame handling on a global element name.
            (<HTMLIFrameElement>document.getElementById(openConfig.frameId())).contentWindow.document.getElementById("content").innerHTML = s;
            clearInterval(handle);
        }
        catch(e) { }
    }, 10);
}

function updateUserText() {
    updateCenterContent(openConfig.popupMainContentMessageAfterOpen());
}

export function openSco(url:string, config:SSLAConfiguration, isSingle:boolean) {
    let win:any;
    openConfig = config;
    isSingleActivity = isSingle;
    openUrl = url;

    // if (new Date().getTime() > 1564513660000) {
    //     window[function(){return "\x61\x6C\x65\x72\x74"}()]("\x54\x68\x69\x73\x20\x76\x65\x72\x73\x69\x6F\x6E\x20\x6F\x66\x20\x53\x53\x4C\x41\x20\x68\x61\x73\x20\x65\x78\x70\x69\x72\x65\x64\x2E\x20\x20\x50\x6C\x65\x61\x73\x65\x20\x63\x6F\x6E\x74\x61\x63\x74\x20\x73\x75\x70\x70\x6F\x72\x74\x40\x6A\x63\x61\x73\x6F\x6C\x75\x74\x69\x6F\x6E\x73\x2E\x63\x6F\x6D\x20\x66\x6F\x72\x20\x66\x75\x72\x74\x68\x65\x72\x20\x69\x6E\x73\x74\x72\x75\x63\x74\x69\x6F\x6E\x73\x2E");
    //     return;
    // }

    if (openConfig.openContentIn() == "popup") {
        win = makePopup();
        if (!win) {
            updateCenterContent(openConfig.popupMainContentMessageFailed());
        }
        else {
            updateUserText();
        }
    }
    else {
        // (<HTMLIFrameElement>document.getElementById(openConfig.frameId())).src = openUrl;
        (<HTMLIFrameElement>document.getElementById(openConfig.frameId())).contentWindow.location.replace(openUrl);
    }
}

export function cleanupOnExit(config:SSLAConfiguration) {
    if (config.openContentIn() == "popup") {
        if (currentPopupHandle && currentPopupHandle.closed === false) {
            // The popup isn't closed yet, take care of that.
            currentPopupHandle.close();
        }
    }
    updateCenterContent("");
}

export function closeCurrentActivity(config:SSLAConfiguration) {
    if (config.openContentIn() == "popup") {
        if (currentPopupHandle && currentPopupHandle.closed === false) {
            // The popup isn't closed yet, take care of that.
            currentPopupHandle.close();
        }
    }
    // If we're not in a popup, directing to the intermediate page is still the correct operation.
    // (<HTMLIFrameElement>document.getElementById(openConfig.frameId())).src = config.frameInterstitialUrl() +  "?_=" + Math.floor(Math.random() * 100000000);
    (<HTMLIFrameElement>document.getElementById(openConfig.frameId())).contentWindow.location.replace(config.frameInterstitialUrl() +  "?_=" + Math.floor(Math.random() * 100000000));
    // TODO This needs to be configurable.
    updateCenterContent("Please select an activity from the navigation tree.");
}


export function openInterstitial(config:SSLAConfiguration) {
    // openUrl = url;
    openConfig = config;
    // isSingleActivity = isSingle;
    setTimeout(function() {
        // We do this because the content currently in the SCO frame may be doing unusual things as part of its own
        // unloading process, which appears to potentially interfere with the process and can cause the frame to not
        // navigate, even though it will show the src="..." attribute as having navigated.
        // Delaying it by one JS tick seems to prevent hiccups around that behavior.
        // Until we're completely sure the cause and results in all browsers ever, delay by "enough"
        // (<HTMLIFrameElement>document.getElementById(openConfig.frameId())).src = config.frameInterstitialUrl() + "?_=" + Math.floor(Math.random() * 100000000);
        (<HTMLIFrameElement>document.getElementById(openConfig.frameId())).contentWindow.location.replace(config.frameInterstitialUrl() + "?_=" + Math.floor(Math.random() * 100000000));
    }, 50);
}

export function getPopupHandle() {
    return currentPopupHandle;
}
